import chroma from "chroma-js";
import _ from "lodash";
import { DefaultTheme, ThemedStyledProps } from "styled-components";
import { AppType } from "../constants/AppType";

export function getThemeSettingValue(
  props: AppStyledProps,
  camelCaseKey: string
) {
  let value = props[camelCaseKey];

  if (
    camelCaseKey.toLowerCase().endsWith("color") &&
    !chroma.valid(value) &&
    !value.match(/var\(--([a-z-0-9,\s]+)\)/)
  ) {
    return "";
  }

  return value ? `${_.kebabCase(camelCaseKey)}: ${value};` : "";
}

export interface AppStyleProps {
  fontSize: string;
}

export type AppStyledProps = ThemedStyledProps<AppStyleProps, DefaultTheme>;
